<div *ngIf="error">
    <div>
        <i class="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
        <p class="d-inline" i18n="@@error-component-name-text">An error occurred in : </p><span>{{componentName}}</span>
    </div>
    <div>
        <i class="fa fa-meh-o mr-1" aria-hidden="true"></i>
        <p class="d-inline" i18n="generic error@@generic-error" *ngIf="error >= 500">There was a problem loading or saving information. Please try again later.</p>
        <p class="d-inline" i18n="error in request@@error-in-request" *ngIf="error === 400">There was an error in the request to the server.</p>
        <p class="d-inline" i18n="error unauthorized@@error-unauthorized" *ngIf="error === 401">You were not authorized to perform the request.</p>
        <p class="d-inline" i18n="error forbidden@@error-forbidden" *ngIf="error === 403">You did not have permission to perform the request.</p>
        <p class="d-inline" i18n="error not found@@error-not-found" *ngIf="error === 404">The requested object could not be found on the server.</p>
        <p class="d-inline" i18n="server is busy error@@server-is-busy" *ngIf="error === 429">There are too many people trying to do the same thing as you, wait a minute and try again.</p>
        <p class="d-inline" i18n="redirect in request@@redirect in request" *ngIf="error < 400 && error >= 300">There was a redirect in the request, wait a minute and the refresh.</p>
    </div>
    <button class="btn btn-link action p-0" i18n="show more info@@show-more-info" (click)="openErrorInfoTableDialog()" (keyup.enter)="openErrorInfoTableDialog()">Show more information</button>
</div>

<ng-template #errorInfoTable>
    <div class="error-info-table-container overflow-hidden workplace-error-dialog-container">
        <div class ="d-flex justify-content-between">
            <div class="w-75 p-2">
            <h2 class="error-title error-title" i18n="@@additional-info"><i class="fa fa-exclamation-triangle ml-2" aria-hidden="true"></i><span class="ml-2">Error details </span></h2>
            <h3 class="h6">Oops! An error seems to have occurred. If the error persists or is causing issues in your
                work day, please report it to the proper channels. To help resolve the issue as quickly as possible, please also
                include a screenshot of this page in your error report.</h3>

            </div>
            <div class="p-2">
                <div class="row">
                    <div class="col-auto">
                        <span i18n="@@support-email" class="span2">Support email:</span>
                        <span class="ms-Icon ms-Icon--Mail small" title="{{email}}"></span>
                        <span class="ml-2"><a href="mailto:{{email}}">{{email}}</a></span>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-auto">
                        <span i18n="@@support-phone" class="span2">Support phone:</span>
                        <i class="fa fa-phone-square small" aria-hidden="true"></i>
                        <span class="ml-2"><a href="tel:{{phone}}">{{phone}}</a></span>
                    </div>
            </div>
        </div>
    </div>
        <div class="error-wrapper p-2 d-flex justify-content-between">
            <div class="container-width">
                <div class="row news-list-item border-bottom w-cell pb-2 pl-2">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@current-user">Current user:</mat-label>
                    </div>
                    <div class="col-8" *ngIf="user && user.displayName">
                        {{user?.displayName}}
                    </div>
                </div>
                <div class="row news-list-item border-bottom w-cell odd-cell p-2">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@user-email">Email:</mat-label>
                    </div>
                    <div class="col-8" *ngIf="user && user.displayName">
                        {{user?.mail}}
                    </div>
                </div>
                <div class="row p-2 news-list-item  border-bottom  w-cell">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@time">Time:</mat-label>
                    </div>
                    <div class="col-10 small">
                        {{currentDate}}
                    </div>
                </div>
                <div class="row p-2 news-list-item  border-bottom w-cell odd-cell">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@internal-eror-code">Internal error code:</mat-label>
                    </div>
                    <div class="col-10 small">
                        {{errorInfo?.status}}
                    </div>
                </div>
                <div class="row p-2 news-list-item  border-bottom w-cell ">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@api-request">Request:</mat-label>
                    </div>
                    <div class="col-10 small word-wrap">
                        {{errorInfo?.url}}
                    </div>
                </div>
                <div class="row p-2 news-list-item  border-bottom  w-cell odd-cell">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@error-message">Error message:</mat-label>
                    </div>
                    <div class="col-10 small word-wrap">
                        {{errorInfo?.message}}
                    </div>
                </div>

                <div class="row p-2 news-list-item  border-bottom w-cell ">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@internal-error-message">Internal error message:</mat-label>
                    </div>
                    <div class="col-10 small">
                        {{errorInfo.error['odata.error']?.message.value}}
                    </div>
                </div>
                <div class="row p-2 news-list-item  border-bottom w-cell odd-cell">
                    <div class="col-2 bolder">
                        <mat-label for="projectRole" i18n="@@stack-trace">Internal error stack trace:
                        </mat-label>
                    </div>
                    <div class="col-10 small">
                        {{errorInfo.error['odata.error']?.message.value}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
